
import { Component, Prop, Vue } from 'vue-property-decorator';

import AppMenu from '@/layouts/partials/AppMenu.vue';
import AppNotifications from '@/layouts/partials/AppNotifications.vue';
import ResponseHandler from '@/components/base/ResponseHandler.vue';
import NotificationList from '@/components/notificationMenu/NotificationsList.vue';

import siteModule from '@/store/site';

@Component({
    components: {
        AppMenu,
        AppNotifications,
        ResponseHandler,
        NotificationList,
    }
})
export default class DefaultLayout extends Vue {
    @Prop({ required: false }) readonly width?: number | string;

    isMenuOpen = false;

    get menuItems() {
        return siteModule.menuItems;
    }
}
